import React from "react";
import { Globe2, ShieldCheck } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES, STATS } from "../data/mock";

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="relative py-24 lg:py-32">
      <div className="container-px mx-auto max-w-7xl">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
          {/* Images */}
          <div className="reveal relative">
            <div className="overflow-hidden rounded-2xl">
              <img src={IMAGES.aboutMain} alt="Warehouse interior" className="grayscale-img h-[460px] w-full object-cover" />
            </div>
            <div className="glass-card absolute -bottom-6 left-6 right-10 rounded-2xl p-5 flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white text-black">
                <ShieldCheck className="h-6 w-6" />
              </div>
              <p className="text-sm font-medium text-white/90 leading-snug">{t.stats.retention}</p>
            </div>
          </div>

          {/* Text */}
          <div className="reveal">
            <p className="text-xs font-semibold tracking-[0.3em] text-white/50">{t.about.eyebrow}</p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white">
              {t.about.title}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-white/65">{t.about.desc}</p>

            <div className="mt-8 space-y-5">
              <div className="glass-card rounded-xl p-5">
                <div className="flex items-start gap-4">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 border border-white/20">
                    <Globe2 className="h-5 w-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-white">
                      {t.about.card1Title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-white/60">{t.about.card1Desc}</p>
                  </div>
                </div>
              </div>
              <div className="glass-card rounded-xl p-5">
                <div className="flex items-start gap-4">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 border border-white/20">
                    <ShieldCheck className="h-5 w-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-white">
                      {t.about.card2Title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-white/60">{t.about.card2Desc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="reveal mt-24 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/5 lg:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.key} className="bg-black/40 px-6 py-10 text-center">
              <div className="font-display text-4xl sm:text-5xl font-bold text-white">{s.value}</div>
              <div className="mt-2 text-xs uppercase tracking-widest text-white/50">{t.stats[s.key]}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
